import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { useMemo, useState } from 'react';

interface Props {
  label: string | React.ReactNode;
  options: Array<{
    label: string;
    icon: React.ReactNode;
    onClick(): void;
  }>;
  onClose(): void;
}

/**
 * Boton de acciones para la tabla en "Plan de desarrollo".
 *
 * Permite aprobar o resetear el estatus de los cursos a un empleado.
 */
const ActionsButton = ({ label, options }: Props) => {
  // Estado para controlar el modal de confirmación.
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // Opciones del menú.
  const menuOptions = useMemo(() => {
    return options.map(({ icon, label, onClick }) => {
      return (
        <MenuItem
          key={label}
          onClick={() => {
            onClick();
            setAnchorEl(null);
          }}
          sx={{ display: 'flex', gap: 1, fontSize: 14, textAlign: 'center' }}
        >
          {icon}
          {label}
        </MenuItem>
      );
    });
  }, [options]);

  // Renderizado.
  return (
    <Box>
      <Button
        onClick={e => {
          setAnchorEl(e.currentTarget);
        }}
      >
        {label}
      </Button>
      <Menu id="actions-menu" open={open} onClose={() => setAnchorEl(null)} anchorEl={anchorEl}>
        {menuOptions}
      </Menu>
    </Box>
  );
};

export default ActionsButton;
